import parse from 'html-react-parser';
import { FC } from 'react';
import styles from './noDataPicture.module.scss';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface NoDataPictureProps {
  id: string;
  picture: string;
  text: string;
  tip?: string;
}

/* eslint-disable @typescript-eslint/no-non-null-assertion */
const NoDataPicture: FC<NoDataPictureProps> = (props) => {
  const { id, picture, text, tip } = props;
  

  return (
    <div id={id} className={styles.noDataPic}>
      <div className={styles.noDataWrapper}>
        <img src={picture} />
        <div className={styles.paragraphs}>
          <div className={styles.paragraph}>{parse(text)}</div>
          {tip && <div className={styles.paragraph}>{parse(tip)}</div>}
        </div>
      </div>
    </div>
  );
};

export default NoDataPicture;
